module.exports = __webpack_public_path__ + "img/servicioHogar.e239b164.jpg";